import { uniqBy } from "lodash-es"
import {
  TRIP_STATUSES,
  USER_STATUSES,
  SELLER_CATEGORIES,
} from "../data/static.items"
import { ORDER_STATUSES } from "../data/orderStatuses"
import { BOOKING_STATUSES } from "../data/bookingStatuses"
const resolvers = {
  BookingType: {
    statusObj(booking: any) {
      return {
        ...BOOKING_STATUSES.find(bs => bs.id === booking?.status),
        __typename: "BookingStatusObj",
      }
    },
  },
  TripType: {
    statusObj(trip: any) {
      return {
        ...TRIP_STATUSES.find(t => t.id === trip?.status),
        __typename: "ClientStatusType",
      }
    },
    uniqueDestinations(trip: any) {
      const filterdAddresses = trip.bookings
        .map(b => b.order?.shippingAddress)
        .filter(a => a?.village)

      return uniqBy(filterdAddresses, (a: any) => a?.id)
    },
  },
  BaseUserType: {
    statusObj(user: any) {
      return {
        ...USER_STATUSES.find(us => us.id === user?.status),
        __typename: "BaseUserStatusType",
      }
    },
  },
  OrderType: {
    orderStatusObj(order: any) {
      return {
        ...ORDER_STATUSES.find(os => os.id === order?.orderStatus),
        __typename: "OrderOrderStatusType",
      }
    },
  },
  SellerType: {
    categoryObj(seller: any) {
      return {
        ...SELLER_CATEGORIES.find(sc => sc.id === seller?.category),
        __typename: "SellerCategoryType",
      }
    },
  },
  SellableItemStockType: {
    totalStockCount(stock: any) {
      const offer = stock?.offerStockCount || 0
      const booked = stock?.bookedStockCount || 0
      return offer + booked
    },
  },
}
export default resolvers
